import {
  CLEF_TRADUCTION,
  manquementsDuMotDePasse,
} from '@stockflow/acces/politique';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

import { AuthService } from '../../services/auth.service';

export interface PasswordState {
  showPasswordModal: boolean;
  currentPwd: string;
  newPwd: string;
  confirmPwd: string;
  pwdError: string;
  pwdSaving: boolean;
  showCurrentPwd: boolean;
  showNewPwd: boolean;
  showConfirmPwd: boolean;
}

export class TopbarPasswordCollab {

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private messageService: MessageService,
  ) {}

  openChangePassword(state: PasswordState, closeAll: () => void): void {
    closeAll();
    state.currentPwd = '';
    state.newPwd = '';
    state.confirmPwd = '';
    state.pwdError = '';
    state.pwdSaving = false;
    state.showCurrentPwd = false;
    state.showNewPwd = false;
    state.showConfirmPwd = false;
    state.showPasswordModal = true;
  }

  closePasswordModal(state: PasswordState): void {
    state.showPasswordModal = false;
  }

  async submitChangePassword(state: PasswordState): Promise<void> {
    state.pwdError = '';

    if (!state.currentPwd || !state.newPwd || !state.confirmPwd) {
      state.pwdError = this.translate.instant('COMMON.REQUIRED') as string;
      return;
    }
    const manquements = manquementsDuMotDePasse(state.newPwd);
    if (manquements.length > 0) {
      state.pwdError = manquements
        .map((m) => this.translate.instant(CLEF_TRADUCTION[m]) as string)
        .join(' · ');
      return;
    }
    if (state.currentPwd === state.newPwd) {
      state.pwdError = this.translate.instant('motDePasse.inchange') as string;
      return;
    }
    if (state.newPwd !== state.confirmPwd) {
      state.pwdError = this.translate.instant('AUTH.PASSWORD_MISMATCH') as string;
      return;
    }

    state.pwdSaving = true;
    try {
      await this.authService.changePassword(state.currentPwd, state.newPwd);
      this.messageService.add({
        severity: 'success',
        summary: this.translate.instant('AUTH.PASSWORD_CHANGED') as string,
      });
      this.closePasswordModal(state);
    } catch (err: any) {
      if (err?.name === 'NotAuthorizedException') {
        state.pwdError = this.translate.instant('AUTH.WRONG_CURRENT_PASSWORD') as string;
      } else if (err?.name === 'InvalidParameterException' || err?.name === 'InvalidPasswordException') {
        state.pwdError = this.translate.instant('AUTH.PASSWORD_POLICY') as string;
      } else {
        state.pwdError = this.translate.instant('COMMON.ERROR') as string;
      }
    } finally {
      state.pwdSaving = false;
    }
  }
}
